import React, { useEffect, useState } from "react";
import { getAllTask, getCollectionImages } from "../../api";
import { BLOB_URL } from "../../AppConstants";
import { getFeaturesPermissions, PICSTORK_FEATURES } from "../../Teams";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const TowerImages = ({ images = {}, userDetails = {}, projectId, planId }) => {
  const [collectionImages, setCollectionImages] = useState([]);
  const [sasToken, setSasToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]); 

  const history = useHistory();

  useEffect(() => {
    const fetchCollectionImages = async () => {
      if (!images || images.length === 0) return;
      try {
        setLoading(true);
        const collectionId = images?.id;
        const res = await getCollectionImages(collectionId, "", 100000, 1);

        if (res?.images?.length > 0) {
          setCollectionImages(res.images);
          setSasToken(res.sasToken);
        }
      } catch (error) {
        console.error("Error fetching collection images:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCollectionImages();
  }, [images]);

  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    getFeaturesPermissions([PICSTORK_FEATURES.IMAGECOLLECTIONS])
      .then((permissions) => {
        setPermissions(permissions);
      })
      .catch((e) => {
        console.error("Error fetching permissions:", e);
      });
  }, []);


   useEffect(() => {
    const fetchTasks = async () => {
      if (!projectId || !planId) return;
      try {
        setLoading(true);
        const res = await getAllTask(projectId, planId, " ", 0, 10000, "PickStork");
        if (res?.tasks) {
          setTasks(res.tasks);
          console.log("Fetched tasks:", res.tasks);
        }
      } catch (error) {
        console.error("Error fetching tasks:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, []);

  // const handleImageClick = (img) => {
  //   const towerClasses = [
  //     { id: 1, class_name: "Tower", color: "#FF0000" },
  //     { id: 2, class_name: "Defect", color: "#00FF00" },
  //     { id: 3, class_name: "Normal", color: "#0000FF" },
  //   ];

  //   const annotationSet = {
  //     id: img.collection_id || images[0]?.id,
  //     annotation_set_name: "Tower Detection",
  //     image_collection_id: img.collection_id || images[0]?.id,
  //   };

  //   // Create a minimal task object (ImagesAnnotation expects this structure)
  //   const task = {
  //     id: `tower-task-${img.id}`,
  //     task_name: "Tower Detection Task",
  //     type: towerClasses, // ImagesAnnotation expects task.type to be the classes array
  //     project_id: projectId,
  //     plan_id: planId,
  //     image_collection_id: img.collection_id || images[0]?.id,
  //   };

  //   // Navigate with all required data
  //   const navigationData = {
  //     user: userDetails,
  //     type: userDetails.type || "user",
  //     image: img,
  //     project: { id: projectId },
  //     plan: { id: planId },
  //     classes: towerClasses,
  //     task: task,
  //     annotationSet: annotationSet,
  //     images: collectionImages,
  //     sidebarMode: "shrunk",
  //   };

  //   console.log("Navigating to tower detector with data:", navigationData);
  //   history.push("/picstork/tower-detector", navigationData);
  // };

  return (
    <div className="image-grid">
      {collectionImages.map((img) => {
        const imageUrl = `${BLOB_URL}/${permissions.container}/FlightImages/collection-${img.collection_id}/thumb-${img.file_name}?${sasToken}`;

        return (
          <div
            key={img.id}
            className="image-card rounded"
            // onClick={() => handleImageClick(img)}
          >
            <div className="image-container relative">
              <img
                className="image" 
                src={imageUrl}
                alt={img.file_name}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
              {/* {img.resolution && ( */}
                <div className="overlay">
                  0 Detections
                </div>
              {/* )} */}
            </div>
            <p className="image-label mt-1 text-sm text-center">
              {img.file_name}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default TowerImages;
